export default __webpack_public_path__ + "static/media/powderCoat.842b6100.jpeg";